const domainDeviceEn = {
  activityType: {
    DECOMMISSIONED: 'decommissioned',
    ORDERED: 'ordered',
    PROCURED: 'procured',
    RECOVERED: 'recovered',
    TROUBLED: 'troubled',
  },
  components: {
    deviceFilters: {
      assigned: {
        label: 'Unassigned Devices',
      },
      deviceGenre: {
        all: 'Genre',
        label: 'Device Type',
        placeholder: 'Select type',
      },
      error: {
        label: 'Abnormal Report',
      },
      reportStatus: {
        all: 'Report Review Status',
        completed: 'Completed',
        label: 'Self Report',
        notCompleted: 'Not Completed',
        placeholder: 'Self Report',
      },
      search: {
        clear: 'Clear Search',
        placeholder: 'Filter devices ...',
      },
    },
    deviceToolbar: {
      showSummary: 'Show Summary',
    },
    statCard: {
      assignedDevices: 'Assigned Devices',
      installedDevices: 'Installed Devices',
      responsiblePersons: 'Users & Responsible Persons',
      totalDevices: 'Devices',
    },
  },
  genre: {
    LAPTOP: 'Laptop',
    MOBILE: 'Mobile',
    MONITOR: 'Monitor',
    OTHER: 'Other',
    SERVER: 'Server',
    TABLET: 'Tablet',
    WORKSTATION: 'Workstation',
  },
  inventoryLabel: {
    labelPreviewDialog: {
      title: 'Asset management label',
    },
    printLabel: {
      generatePdf: 'Generate PDF',
      labelSpecs: {
        '10_labels_A4': '10 labels size (A4)',
        '12_labels_A4': '12 labels size (A4)',
        '21_labels_A4': '21 labels size (A4)',
        '65_labels_A4': '65 labels size (A4)',
      },
      printOptions: {
        additionalContent: 'Additional content',
        assetTag: 'Asset tag',
        deviceName: 'Device name',
        horizontal: 'Horizontal',
        labelColor: 'Label color',
        labelFont: 'Label font',
        labelFontSize: 'Label font size',
        labelSize: 'Label size',
        labelType: 'Label type',
        layout: 'Layout',
        margin: 'Margin',
        none: 'None',
        paperSize: 'Paper size',
        qrCode: 'QR code',
        vertical: 'Vertical',
      },
    },
  },
  monthlyEditGrid: {
    contractSelect: {
      label: 'Contract',
      placeholder: 'Select a contract',
    },
    table: {
      actual: 'Actual',
      averageMonthlyLeaseCost: 'Average Monthly Lease Cost',
      averageUnitPrice: 'Average Unit Price',
      planned: 'Planned',
      quantity: 'Quantity',
      total: 'Total',
      unit: 'Unit: {{currency}}',
      variance: 'Variance',
    },
  },
  networkInterfaceType: {
    ETHERNET: 'Ethernet',
    IEEE_802_11: 'WiFi',
    IEEE_802_15_1: 'Bluetooth',
    UNKNOWN: 'Unknown',
  },
  osPlatformType: {
    ANDROID: 'Android',
    IOS: 'iOS',
    LINUX: 'Linux',
    MACOS: 'macOS',
    OTHER: 'Other',
    TVOS: 'tvOS',
    VISIONOS: 'visionOS',
    WATCHOS: 'watchOS',
    WINDOWS: 'Windows',
  },
  procurementType: {
    BYOD: 'BYOD',
    LEASE: 'Lease',
    OTHER: 'Other',
    PURCHASE: 'Purchase',
    RENTAL: 'Rental',
  },
  purchaseCondition: {
    NEW: 'New',
    USED: 'Used',
  },
  storageType: {
    HDD: 'HDD',
    SSD: 'SSD',
    UNKNOWN: 'Unknown',
  },
  type: {
    computer: 'Desktop, Laptop',
    mobile: 'Mobile, Tablet',
    monitor: 'Monitor',
    other: 'Others',
    server: 'Server',
    short: {
      computer: 'Desktop, Laptop',
      mobile: 'Mobile, Tablet',
      monitor: 'Monitor',
      other: 'Others',
      server: 'Server',
    },
  },
};

export default domainDeviceEn;
